// extracted by mini-css-extract-plugin
export default {"editor":"htmlEditor_editor__N0w4w"};